import { Project } from '../../../domain/projects/project';
import { ProjectFilesList } from '../../../domain/projects/projectFilesList';
import { ProjectList } from '../../../domain/projects/projectList';
import { ProjectDTO } from '../../http/dtos/projects/projectDTO';
import { ProjectFilesListDTO } from '../../http/dtos/projects/projectFilesListDTO';
import { ProjectListDTO } from '../../http/dtos/projects/projectListDTO';

const getProjectsListAdapter = (responseAPI: ProjectListDTO[]): ProjectList[] => {
    return responseAPI
        ? responseAPI.map((project) => {
              return {
                  id: project.id,
                  name: project.name,
                  commercialName: project.commercialName,
                  percentage: project.percentage,
                  totalCost: project.totalCost,
                  commercialEmployee: project.commercialEmployee,
                  consultant: project.consultant,
                  productChannel: project.productChannel,
                  color: project.color,
                  stateName: project.stateName,
              };
          })
        : [];
};

const getProjectAdapter = (responseAPI: ProjectDTO): Project => {
    return {
        id: responseAPI.id,
        name: responseAPI.name,
        customerName: responseAPI.customerName,
        percentage: responseAPI.percentage,
        totalCost: responseAPI.totalCost,
        cityId: responseAPI.cityId,
        cityName: responseAPI.cityName,
        customerId: responseAPI.customerId,
        productId: responseAPI.productId,
        productName: responseAPI.productName,
        startDate: responseAPI.startDate,
        endDate: responseAPI.endDate,
        realEndDate: responseAPI.realEndDate,
        scheduledDate: responseAPI.scheduledDate,
        projectStatusId: responseAPI.projectStatusId,
        summary: responseAPI.summary,
        customerContacts: responseAPI.customerContacts,
        employees: responseAPI.employees,
    };
};

const getProjectFilesList = (
    responseAPI: ProjectFilesListDTO[]
): ProjectFilesList[] => {
    return responseAPI
        ? responseAPI.map((projectFiles) => {
              return {
                  id: projectFiles.id,
                  name: projectFiles.name,
                  containerName: projectFiles.containerName,
                  extension: projectFiles.extension,
                  url: projectFiles.url,
              };
          })
        : [];
};

export const ProjectsAdapter = {
    getProjectAdapter,
    getProjectsListAdapter,
    getProjectFilesList,
};
